import { FunctionComponent, useEffect, useState } from "react";
import TabAtom, { TabAtomType } from "../../../src/atoms/tab";

export type TabType = {
  width: "fill-container" | "hug-content";
  type: "horizontal" | "vertical";
  className?: string;
  tabs: TabAtomType[];
  selected?: TabAtomType;
  size?: "sm" | "md";
  onChange?: (tab: TabAtomType) => void;
};

export const Tab: FunctionComponent<TabType> = ({
  width = "fill-container",
  className = "",
  tabs = [],
  selected: externalSelected = null,
  size = "sm",
  type = "horizontal",
  onChange,
}) => {
  const [selected, setSelected] = useState(externalSelected);

  useEffect(() => {
    setSelected(externalSelected);
  }, [externalSelected]);

  const displayTabs =
    width === "fill-container" && type === "horizontal"
      ? tabs.slice(0, 3)
      : tabs;

  return (
    <div
      className={[
        `quill-ui-next-component ${
          type === "horizontal" ? "quill-ui-next-full-width" : ""
        }`,
        "quill-next-ui-tab-container",
        `size-${size}`,
        width,
        type,
        className,
      ].join(" ")}
    >
      {displayTabs.map((tab) => (
        <TabAtom
          key={`quill-ui-next-tab-${tab.label}`}
          {...tab}
          size={size}
          selected={selected?.label === tab.label}
          type={type}
          onClick={() => {
            setSelected(tab);
            onChange?.(tab);
            tab.onClick?.();
          }}
        />
      ))}
    </div>
  );
};

Tab.displayName = "Tab";
export default Tab;
